@import '../../../../../style/lib/scss';
@import '../../../../../style/src/typography/mixins';
@import '../../../mixins/outline';

:host {
	@include zds-typography('body');

	display: block;
}

.zds-navigation-panel-link {
	@include outline;

	color: var(--zds-navigation-color);
	display: flex;
	padding: var(--zds-space-3) 0;
	text-decoration: none;
	text-transform: var(--zds-navigation-link-text-transform);

	@include zds-media-breakpoint-up('md') {
		padding: var(--zds-space-2) 0;
	}

	&[href]:hover {
		text-decoration: underline;
	}

	&__icon {
		align-items: center;
		display: flex;
		flex-shrink: 0;
		height: calc(
			var(--zds-typography-headline-md-line-height) * var(--zds-navigation-panel-link-size)
		); // Match the height of a single line of text

		margin-right: var(--zds-space-2);
	}
}

:host([level='1']) {
	@include zds-typography('headline-md');

	font-size: var(--zds-navigation-panel-link-size);
	font-weight: var(--zds-navigation-panel-link-font-weight);

	.zds-navigation-panel-link {
		color: var(--zds-navigation-panel-link-color);

		&[href]:hover {
			color: var(--zds-navigation-panel-link-color-hover);
		}

		::slotted(zds-icon) {
			font-size: var(--zds-navigation-panel-link-size);
		}
	}
}

:host([level='2']) {
	.zds-navigation-panel-link {
		color: var(--zds-navigation-panel-link-level-2-color);

		&[href]:hover {
			color: var(--zds-navigation-panel-link-level-2-color-hover);
		}
	}
}
